import React from 'react';
import { Link } from 'react-router-dom';

type RelatedPagesProps = {
  currentPath?: string;
};

const FREE_TRIAL_URL = 'https://buy.stripe.com/5kA6rt11z6Dw06YbII';

const GUIDE_LINKS: { to: string; label: string }[] = [
  { to: '/how-it-works', label: 'How it works' },
  { to: '/betfair-connection-and-security', label: 'Betfair connection & security' },
  { to: '/staking-and-risk-controls', label: 'Staking & risk controls' },
  { to: '/who-its-for', label: "Who it's for" },
];

const CORE_LINKS: { to: string; label: string; external?: boolean }[] = [
  { to: '/', label: 'Home' },
  { to: FREE_TRIAL_URL, label: 'Free trial', external: true },
  { to: '/faqs', label: 'FAQs' },
  { to: '/contact', label: 'Contact' },
  { to: '/privacy-policy', label: 'Privacy policy' },
  { to: '/terms-conditions', label: 'Terms & conditions' },
  { to: '/refund-policy', label: 'Refund policy' },
];

export default function RelatedPages({ currentPath }: RelatedPagesProps) {
  const guides = GUIDE_LINKS.filter((l) => l.to !== currentPath);
  const core = CORE_LINKS.filter((l) => l.to !== currentPath);

  return (
    <section className="mt-12 pt-8 border-t border-gray-200" aria-labelledby="related-pages-heading">
      <h2 id="related-pages-heading" className="text-lg font-semibold text-gray-900 mb-4">
        Related pages
      </h2>
      <div className="grid sm:grid-cols-2 gap-6 text-sm">
        <div>
          <h3 className="font-medium text-gray-700 mb-2">Guides</h3>
          <ul className="space-y-1.5 text-primary-600">
            {guides.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="hover:text-primary-800 underline">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-medium text-gray-700 mb-2">Site</h3>
          <ul className="space-y-1.5 text-primary-600">
            {core.map(({ to, label, external }) => (
              <li key={to}>
                {external ? (
                  <a href={to} className="hover:text-primary-800 underline" rel="noopener noreferrer">
                    {label}
                  </a>
                ) : (
                  <Link to={to} className="hover:text-primary-800 underline">
                    {label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
